import DimensionDescriptionInstructionsLayout from "./layouts/instructions";
import DimensionDescriptionTextLayout from "./layouts/text";
import DimensionDescriptionThumbnailsLayout from "./layouts/thumbnails";

const SurveyDimensionDescription = ({ descriptionData }) => {
  const { title, data, layout_type: layoutType } = descriptionData;

  const renderBody = () => {
    switch (layoutType) {
      case "instructions":
        return (
          <div className="card-body">
            <DimensionDescriptionInstructionsLayout data={data} />
          </div>
        );
      case "thumbnails":
        return (
          <div className="card-body">
            <DimensionDescriptionThumbnailsLayout data={data} />
          </div>
        );
      case "text":
        return (
          <div className="card-body">
            <DimensionDescriptionTextLayout data={data} />
          </div>
        );
      case "blank":
      default:
        return <div></div>;
    }
  };

  return (
    <div className="card mb-4">
      <div className="card-header yellow">{title ?? "Antes de responder las preguntas"}</div>
      {renderBody()}
    </div>
  );
};

export default SurveyDimensionDescription;
